/**
 * @generated SignedSource<<30e67a7028d529630069fbc7e9b96a08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLandingBannerArticle$data = {
  readonly coverDesktop: {
    readonly sizeLandscape250x99: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly url: string;
  } | null | undefined;
  readonly coverMobile: {
    readonly url: string;
  } | null | undefined;
  readonly headline: string | null | undefined;
  readonly images: ReadonlyArray<{
    readonly isSlideshow: boolean | null | undefined;
    readonly size768x768: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size800x1200: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly sizeLandscape250x99: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle" | "articleSponsorContent">;
  readonly " $fragmentType": "articleLandingBannerArticle";
};
export type articleLandingBannerArticle$key = {
  readonly " $data"?: articleLandingBannerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLandingBannerArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": "sizeLandscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLandingBannerArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": "size768x768",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "768x768"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"768x768\"})"
        },
        {
          "alias": "size800x1200",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "800x1200"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"800x1200\"})"
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "coverDesktop",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "COVER"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": "image(filter:{\"type\":\"COVER\"})"
    },
    {
      "alias": "coverMobile",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "COVER_MOBILE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "13aa1b8c23c27f90b6942dafaeb82265";

export default node;
